export const VALIDATION = {
  EMAIL: 'Email is invalid',
  PASSWORD_NOT_MATCH: 'Passwords do not match',
  PASSWORD: 'Your password needs to be atleast 6 character long and include one symbol',
  INCORRECT_CURRENT_PASSWORD: 'Please check your pasword and try again',
};
